import type { TFunction } from "i18next";

import { PERSONA_STATUS_BADGE_BASE } from "./persona-status";
import type { PersonaType } from "../types/personas.types";

/** Shared chip geometry — matches PersonaStatusBadge (Figma status chips). */
export const PERSONA_TYPE_BADGE_BASE = PERSONA_STATUS_BADGE_BASE;

export function personaTypeIsIndustry(type: PersonaType): boolean {
  return type === "INDUSTRY_SUGGESTED";
}

/** Library-surface type label — Core / Industry. MANUAL personas read as Core. */
export function personaTypeLabel(t: TFunction, type: PersonaType): string {
  if (personaTypeIsIndustry(type)) {
    return t("personas.table.typeIndustry", "Industry");
  }
  return t("personas.table.typeCore", "Core");
}

export function personaTypeBadgeClassName(type: PersonaType): string {
  if (personaTypeIsIndustry(type)) {
    return "bg-[var(--violet-subtle)] text-[var(--violet-subtle-foreground)] ring-1 ring-inset ring-[color-mix(in_oklch,var(--violet-subtle-foreground)_25%,transparent)]";
  }
  return "bg-[var(--slate-chip-bg)] text-[var(--slate-chip-text)] ring-1 ring-inset ring-border/60";
}
